import axios from 'utils/axios';

export const createTariffAdmin = (name: string, price: number) => {
  return axios.post(`/api/v1/tariffs`, {
    active: true,
    name,
    price,
  });
};
